[
  {
    "code": "NG-AB",
    "name": "Abia"
  },
  {
    "code": "NG-FC",
    "name": "Abuja Federal Capital Territory"
  },
  {
    "code": "NG-AD",
    "name": "Adamawa"
  },
  {
    "code": "NG-AK",
    "name": "Akwa Ibom"
  },
  {
    "code": "NG-AN",
    "name": "Anambra"
  },
  {
    "code": "NG-BA",
    "name": "Bauchi"
  },
  {
    "code": "NG-BY",
    "name": "Bayelsa"
  },
  {
    "code": "NG-BE",
    "name": "Benue"
  },
  {
    "code": "NG-BO",
    "name": "Borno"
  },
  {
    "code": "NG-CR",
    "name": "Cross River"
  },
  {
    "code": "NG-DE",
    "name": "Delta"
  },
  {
    "code": "NG-EB",
    "name": "Ebonyi"
  },
  {
    "code": "NG-ED",
    "name": "Edo"
  },
  {
    "code": "NG-EK",
    "name": "Ekiti"
  },
  {
    "code": "NG-EN",
    "name": "Enugu"
  },
  {
    "code": "NG-GO",
    "name": "Gombe"
  },
  {
    "code": "NG-IM",
    "name": "Imo"
  },
  {
    "code": "NG-JI",
    "name": "Jigawa"
  },
  {
    "code": "NG-KD",
    "name": "Kaduna"
  },
  {
    "code": "NG-KN",
    "name": "Kano"
  },
  {
    "code": "NG-KT",
    "name": "Katsina"
  },
  {
    "code": "NG-KE",
    "name": "Kebbi"
  },
  {
    "code": "NG-KO",
    "name": "Kogi"
  },
  {
    "code": "NG-KW",
    "name": "Kwara"
  },
  {
    "code": "NG-LA",
    "name": "Lagos"
  },
  {
    "code": "NG-NA",
    "name": "Nassarawa"
  },
  {
    "code": "NG-NI",
    "name": "Niger"
  },
  {
    "code": "NG-OG",
    "name": "Ogun"
  },
  {
    "code": "NG-ON",
    "name": "Ondo"
  },
  {
    "code": "NG-OS",
    "name": "Osun"
  },
  {
    "code": "NG-OY",
    "name": "Oyo"
  },
  {
    "code": "NG-PL",
    "name": "Plateau"
  },
  {
    "code": "NG-RI",
    "name": "Rivers"
  },
  {
    "code": "NG-SO",
    "name": "Sokoto"
  },
  {
    "code": "NG-TA",
    "name": "Taraba"
  },
  {
    "code": "NG-YO",
    "name": "Yobe"
  },
  {
    "code": "NG-ZA",
    "name": "Zamfara"
  }
]